const binding = { modules: {}, dataActions: {} };

    (binding.modules['herbal-intro-block'] = {
        c: () => require('partner/modules/herbal-intro-block/herbal-intro-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'herbal-intro-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/herbal-intro-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|herbal-intro-block|herbal-intro-block'] = {
                c: () => require('partner/modules/herbal-intro-block/herbal-intro-block.view.tsx'),
                cn: '__local__-__local__-herbal-intro-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };